import { useState, useCallback } from "react";

export type ToastType = "success" | "error" | "warning" | "info";

export interface ToastConfig {
  message: string;
  type: ToastType;
  duration?: number; // en ms, par défaut 3000 pour success, infini pour les autres
}

export function useToast() {
  const [toast, setToast] = useState<ToastConfig & { isVisible: boolean }>({
    message: "",
    type: "info",
    isVisible: false,
    duration: 3000,
  });

  const showToast = useCallback((config: ToastConfig) => {
    const defaultDuration = config.type === "success" ? 3000 : undefined;
    setToast({
      ...config,
      duration: config.duration ?? defaultDuration,
      isVisible: true,
    });
  }, []);

  const hideToast = useCallback(() => {
    setToast((prev) => ({ ...prev, isVisible: false }));
  }, []);

  return { toast, showToast, hideToast };
}

